export const isGuestCustomer = (customerId) => {
    if (customerId === null || customerId === undefined) return true;
    const idStr = customerId.toString().trim().toLowerCase();
    return idStr === '' || idStr === '0';
};
